var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-7"},[(_vm.child)?_c('catalog-sections',{attrs:{"parent":_vm.sectionID}}):_vm._e(),_vm._l((_vm.products[_vm.sectionID]),function(product,i){return _c('product-card',{key:i,attrs:{"product":product,"section":_vm.sectionID}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }